import { BillToOverrideTable } from "../../../dispatch/src/BillToOverrideTable";
import { CallRecordTable } from "../../../dispatch/src/CallRecordTable";
import { DetentionDefinitionTable } from "../../../dispatch/src/DetentionDefinitionTable";
import { DetentionSummary } from "../../../dispatch/src/DetentionSummary";
import { ProductBookTable } from "../../../dispatch/src/ProductBookTable";
import { ProhibitedTable } from "../../../dispatch/src/ProhibitedTable";
import { TableComment } from "../../../general/src/TableComment";
import { TableContact } from "../../../general/src/TableContact";
import { TableRateExceptions } from "../../../powerbroker/src/TableRateExceptions";
import { CustomerOptions } from "../CustomerOptions";
import { Financials } from "../Financials";
import { Attachment, Button, Checkbox, CityState, DataHeader, DataSource, Label, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCustomer extends Layout {
    attachmentBlLogo: Attachment;
    buttonAllCalls: Button;
    buttonCustomerUsers: Button;
    buttonOpenClassic: Button;
    buttonReports: Button;
    checkboxChargeDetention: Checkbox;
    checkboxEnableNotifications: Checkbox;
    checkboxGlobalDetention: Checkbox;
    dataheaderCustomer: DataHeader;
    labelBillToOverride: Label;
    labelBillofLadingImage: Label;
    labelHeaderContactEmail: Label;
    labelHeaderContactName: Textbox;
    labelHeaderContactPhone: Label;
    labelHeaderLocAddr: Label;
    labelHeaderLocCSZ: CityState;
    labelHeaderLocName: Textbox;
    labelRateExceptions: Label;
    labelSalespersonEmail: Label;
    labelSalespersonPhone: Label;
    layoutBillToOverrideTable: BillToOverrideTable;
    layoutCallRecord: CallRecordTable;
    layoutContactTable: TableContact;
    layoutCustomerOptions: CustomerOptions;
    layoutDetentionDefinitionTable: DetentionDefinitionTable;
    layoutDetentionSummary: DetentionSummary;
    layoutFinancials: Financials;
    layoutImageTable: Layout;
    layoutProductBookTable: ProductBookTable;
    layoutProhibited: ProhibitedTable;
    layoutRateExceptions: TableRateExceptions;
    layoutTableComment: TableComment;
    panelAutoRate1: Panel;
    panelAutoRate2: Panel;
    panelGeneral1: Panel;
    panelGeneral2: Panel;
    panelGeneral3: Panel;
    panelGeneral4: Panel;
    panelHeader: Panel;
    panelHeaderContact: Panel;
    panelHeaderCustomer: Panel;
    panelHeaderSalesperson: Panel;
    panelSalesCalls: Panel;
    sourceAgencyLink: DataSource;
    sourceBolBillToOverride: DataSource;
    sourceCallRecord: DataSource;
    sourceComments: DataSource;
    sourceContacts: DataSource;
    sourceCreditOverride: DataSource;
    sourceCustomer: DataSource;
    sourceCustomerAging: DataSource;
    sourceDetentionDef: DataSource;
    sourceDetentionHistoryLookup: DataSource;
    sourceLocationCommodity: DataSource;
    sourceProhibited: DataSource;
    sourceRateExceptions: DataSource;
    tabAutoRate: Tab;
    tabBillofLading: Tab;
    tabComments: Tab;
    tabContacts: Tab;
    tabDetention: Tab;
    tabFinancials: Tab;
    tabGeneral: Tab;
    tabImages: Tab;
    tabOptions: Tab;
    tabProductBook: Tab;
    tabProhibited: Tab;
    tabSalesCalls: Tab;
    tabsetMain: Tabset;
    textCityState: CityState;
    textboxAccountManager: Textbox;
    textboxAddress1: Textbox;
    textboxAddress2: Textbox;
    textboxAllowWebTendering: Textbox;
    textboxBlanketBuyTariffId: Textbox;
    textboxBlanketSellTariffId: Textbox;
    textboxBridgeId: Textbox;
    textboxBusinessHours: Textbox;
    textboxBuyTariffId: Textbox;
    textboxCategory: Textbox;
    textboxCertOfInsDate: Textbox;
    textboxDaysBetweenCalls: Textbox;
    textboxDotNumber: Textbox;
    textboxEnteredDate: Textbox;
    textboxFakProfileId: Textbox;
    textboxGooglePlacesSearch: Textbox;
    textboxId: Textbox;
    textboxIsActive: Textbox;
    textboxMotorCarrierId: Textbox;
    textboxName: Textbox;
    textboxNextCallDate: Textbox;
    textboxOperationsUser: Textbox;
    textboxP44ProfileId: Textbox;
    textboxPrevCode: Textbox;
    textboxProspectTypeId: Textbox;
    textboxRateOverrideNmfcCode: Textbox;
    textboxSMC3ProfileId: Textbox;
    textboxSalespersonId: Textbox;
    textboxSalespersonName: Textbox;
    textboxSellTariffId: Textbox;
    textboxWebsiteUrl: Textbox;
}
